import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { IUserPromiseLookupService } from "../IUserPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class UserReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.UserImpl>
  implements IUserPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(factory, CubiqTS.UserImpl, "UserImpl");
  }

  getUser(code: string): Promise<CubiqTS.UserImpl> {
    let request = new UiArguments("getUser");
    let arg1 = new FnArg(code, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getUsers(ids: number[]): Promise<CubiqTS.UserImpl[]> {
    let request = new UiArguments("getUsers");
    let arg1 = new FnArg(ids, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  getLoggedInUser(): Promise<CubiqTS.UserImpl> {
    let request = new UiArguments("getLoggedInUser");
    request.args = [];
    return this.broker.runOnService(request, this.VALUE);
  }

  getUsersByClientCode(clientCode: string): Promise<CubiqTS.UserImpl[]> {
    let request = new UiArguments("getUsersByClientCode");
    let arg1 = new FnArg(clientCode, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }

  changePassword(
    oldPassword: string,
    newPassword: string,
    newPasswordConfirmation: string,
    adminRequested: boolean,
    userCd: string,
  ): Promise<any> {
    let request = new UiArguments("changePassword");
    let arg1 = new FnArg(oldPassword, PRIMITIVE);
    let arg2 = new FnArg(newPassword, PRIMITIVE);
    let arg3 = new FnArg(newPasswordConfirmation, PRIMITIVE);
    let arg4 = new FnArg(adminRequested, PRIMITIVE);
    let arg5 = new FnArg(userCd, PRIMITIVE);
    request.args = [arg1, arg2, arg3, arg4, arg5];
    return this.broker.runOnService(request, PRIMITIVE);
  }

  isChangePasswordRequested(): Promise<boolean> {
    let request = new UiArguments("isChangePasswordRequested");
    request.args = [];
    return this.broker.runOnService(request, PRIMITIVE);
  }
}
